<template>
  <div>
    <canvas
      ref="signatureCanvas"
      class="signature-canvas"
    />
    <div class="buttons">
      <button
        class="button is-light"
        type="button"
        @click="clearSignature"
      >
        {{ $t('clear') }}
      </button>
      <button
        class="button is-light"
        type="button"
        @click="saveSignature"
      >
        {{ $t('save') }}
      </button>
    </div>
  </div>
</template>

<script>
import SignaturePad from "signature_pad";

export default {
  name: "signature-pad",
  data() {
    return {
      signaturePad: null,
    };
  },
  mounted() {
    const canvas = this.$refs.signatureCanvas;
    canvas.width = 400;
    canvas.height = 200;
    this.signaturePad = new SignaturePad(canvas);
  },
  methods: {
    clearSignature() {
      this.signaturePad.clear();
    },
    saveSignature() {
      if (this.signaturePad.isEmpty()) {
        this.$emit("error");
        return;
      }
      const signatureData = this.signaturePad.toDataURL("image/png");
      this.$emit("success", signatureData);
    }
  }
};
</script>

<style scoped>
.signature-canvas {
  border: 1px solid #d1d5dc;
  background-color: #f7f7f7;
  border-radius: 10px;
}
</style>
